import { AdminLayout } from 'components/admin/admin-layout';
import { ShippingBlock } from 'components/admin/settings/shipping/shipping-block';
import { useState } from 'react';
import { BookSellerBlock } from 'components/admin/settings/booksellers/book-seller-block';
import { GeneralBlock } from '../../components/admin/settings/general/general-block';
import { OtherBlock } from '../../components/admin/settings/other/other-block';

const tabs = [
  { name: 'General', component: <GeneralBlock /> },
  { name: 'Shipping', component: <ShippingBlock /> },
  { name: 'Book Sellers', component: <BookSellerBlock /> },
  { name: 'Other', component: <OtherBlock /> },
] as const;

export const Settings = () => {
  const [selectedTab, setSelectedTab] = useState<typeof tabs[number]>(tabs[0]);

  const tabIsSelected = (tabName: typeof tabs[number]['name']) =>
    selectedTab.name === tabName;

  return (
    <>
      <AdminLayout page='Settings'>
        <article className='w-full'>
          <header className='flex flex-col xl:flex-row flex-wrap w-full  space-y-4 xl:space-y-0 '>
            <h1 className='header text-4xl ml-auto mr-auto xl:ml-0 xl:mr-0 order-1'>
              Settings
            </h1>
          </header>
          <nav
            role='settings-navigation'
            className='md:border-b-2 md:border-gray-200'>
            <select
              name='tab'
              id='tab'
              value={selectedTab.name}
              onChange={(e) =>
                setSelectedTab(
                  tabs.find(
                    (t) => t.name === e.target.value
                  ) as typeof tabs[number]
                )
              }
              className='mt-1 block w-full pl-3 pr-10 py-2 text-base border-gray-300 focus:outline-none focus:ring-green-default focus:border-green-default sm:text-sm rounded-md md:hidden'>
              {tabs.map((t) => (
                <option key={t.name} value={t.name}>
                  {t.name}
                </option>
              ))}
            </select>
            <ul className='hidden md:flex flex-row justify-center space-x-8 xl:justify-start'>
              {tabs.map((t) => (
                <li key={t.name} className='flex -mb-px'>
                  <button
                    type='button'
                    onClick={() => setSelectedTab(t)}
                    className={`${
                      tabIsSelected(t.name)
                        ? 'border-green-default text-green-default'
                        : 'border-transparent text-gray-500'
                    } border-b-2 -mb-px hover:border-green-default hover:text-green-default whitespace-nowrap py-4 px-1 font-medium`}>
                    {t.name}
                  </button>
                </li>
              ))}
            </ul>
          </nav>
          {selectedTab.component}
        </article>
      </AdminLayout>
    </>
  );
};

export default Settings;
